import { Dispositivo, DispositivoForm } from '@models/.';

export function transformToData(device: Dispositivo | null): Dispositivo | null {
  if (!device) return null;
  
  return {
    ...device,
  };
}

export function transformToForm(device?: Dispositivo): DispositivoForm | undefined {
  if (!device) return;
  
  const {
    idDispositivo: id,
    nombre: name,
    tipo: type,
    disponible: available,
    tiendaId: localId,
    licenciaEstadoId: licenseStatusId,
  } = device
  
  return {
    id,
    name,
    type,
    available,
    localId,
    licenseStatusId,
  };
}